/* eslint-disable */
// Sidebar Routers
export const menus = [
	{
		path: '/',
		name: 'Inicio',
		icon: 'home',
		children: null,
	},
	{
		path: '/funcionalidades',
		name: 'Funcionalidades',
		icon: 'pages',
		children: null,
	},
	{
		path: '/negocios',
		name: 'Tipos de negocio',
		icon: 'pages',
		children: null,
	},
	{
		path: '/planes',
		name: 'Planes',
		icon: 'party_mode',
		children: null,
	},
	{
		path: '/mejora-tu-diseño',
		name: 'Mejora tu diseño',
		icon: 'perm_contact_calendar',
		children: null,
	},
	{
		path: '/soporte',
		name: 'Soporte',
		icon: 'perm_contact_calendar',
		children: null,
	},
];

export const adminPanelMenus = [
	{
		path: '/dashboard',
		name: 'Dashboard',
		icon: 'mdi-poll',
		children: null,
		active: true,
	},
	{
		path: '/tenants',
		name: 'Clientes',
		icon: 'mdi-account-multiple',
		children: null,
		active: false,
	},
	{
		path: '/plans',
		name: 'Planes',
		icon: 'mdi-cart',
		children: null,
		active: false,
	},
	{
		path: '/plans',
		name: 'Facturación',
		icon: 'mdi-file-document',
		children: null,
		active: false,
	},
	{
		path: 'asd',
		name: 'Negocios',
		icon: 'mdi-poll',
		children: null,
		active: false,
	},
	{
		path: '/business',
		name: 'Empresa',
		icon: 'mdi-home',
		active: false,
		children: null,
	},
	{
		path: '/settings',
		name: 'Configuración',
		icon: 'mdi-apps',
		active: false,
		children: null,
	},
	{
		path: '/',
		name: 'Ir al sitio',
		icon: 'mdi-home',
		active: false,
		children: null,
	},
];
